




import {Vue, Component} from 'vue-property-decorator';
import store from './store';

@Component({
  store,
})
export default class App extends Vue {
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/app.vue